<template>
  <div>
    <PaginationWrapper
      export
      :page="page"
      :totalCount="totalCount"
      @onPageChange="handlePageChange"
      @exportTable="exportList"
    >
      <AlarmSettingsSearchOptions
        @onSearch="handleSearch"
        slot="search-options"
      />
      <div slot="table">
        <AlarmSettingsTable @openModal="openAlarmSettingsDetailModal" />
      </div>
    </PaginationWrapper>
    <AlarmSettingsDetailModal
      v-if="activeAlarmSettings"
      :showModal="alarmSettingsDetailModalVisible"
      :alarmSetting="activeAlarmSettings"
      @save="editAlarmSetting"
      @close="alarmSettingsDetailModalVisible = false"
    />
  </div>
</template>

<script>
import PaginationWrapper from '@/components/sections/common/PaginationWrapper.vue';
import AlarmSettingsSearchOptions from '@/components/sections/alarms/AlarmSettingsSearchOptions';
import AlarmSettingsTable from '@/components/sections/alarms/AlarmSettingsTable';
import AlarmSettingsDetailModal from '@/components/sections/alarms/AlarmSettingsDetailModal';

export default {
  name: 'AlarmSettings',
  components: {
    PaginationWrapper,
    AlarmSettingsSearchOptions,
    AlarmSettingsTable,
    AlarmSettingsDetailModal,
  },
  data() {
    return {
      query: {},
      alarmSettingsDetailModalVisible: false,
      activeAlarmSettings: undefined,
      page: 1,
      totalCount: 0,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.$store.dispatch('storeLoading', true);
      this.totalCount = await this.$store.dispatch('storeAlarmSettings', {
        query: { ...this.query },
        page: this.page,
      });
      this.$store.dispatch('storeLoading', false);
    },
    async handleSearch(query) {
      this.page = 1;
      this.query = query;
      await this.fetchData();
    },
    async handlePageChange(page) {
      this.page = page;
      await this.fetchData();
    },
    async openAlarmSettingsDetailModal(alarmSetting) {
      this.$store.dispatch('storeLoading', true);
      this.alarmSettingsDetailModalVisible = true;
      this.activeAlarmSettings = alarmSetting;
      this.$store.dispatch('storeLoading', false);
    },
    async editAlarmSetting(updatedAlarmSetting) {
      try {
        await this.$store.dispatch('editAlarmSetting', {
          alarmSetting: updatedAlarmSetting,
        });
        this.$message.success(
          this.$t('components.alerts.createSuccess', { type: 'alarm setting' }),
        );
        this.alarmSettingsDetailModalVisible = false;
        await this.fetchData();
      } catch (e) {
        this.$message.error(
          this.$t('components.alerts.createError', { type: 'alarm setting' }),
        );
      }
    },
    async exportList() {
      await this.$store.dispatch('storeLoading', true);

      try {
        const file = await this.$store.dispatch('exportList', {
          query: { ...this.query },
          type: 'alarms',
          subType: 'alarm-settings',
        });

        if (file.data === '') {
          this.$message.error(
            this.$t('components.alerts.exportFileError', {
              type: 'alarmsSettings',
            }),
          );
        } else {
          const fileURL = window.URL.createObjectURL(new Blob([file.data]));
          const fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute(
            'download',
            `alarmsSettings-${new Date()
              .toISOString()
              .slice(0, 10)
              .replaceAll('-', '')}.csv`,
          );
          document.body.appendChild(fileLink);

          fileLink.click();
          this.$message.success(
            this.$t('components.alerts.exportSuccess', { type: 'alarmsSettings' }),
          );
        }
      } catch (e) {
        this.$message.error(
          this.$t('components.alerts.exportError', { type: 'alarmsSettings' }),
        );
        console.log(e);
      }

      await this.$store.dispatch('storeLoading', false);
    },
  },
};
</script>
